// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Statements/import
import state from './state'
import mutations from './mutations'
import * as actions from './actions'
import * as getters from './getters'

import {vuexModuleName} from '../config'

export default {
  [vuexModuleName]:{ state, mutations, actions, getters }
}


